//界面toast提示
/*使用方法 Toast('这是一个弹框',2000)  father_element 为居中显示的父元素，duration 为弹框显示时间，单位为毫秒*/
export default function Toast(msg, father_element = 'displayZone', y = 50, duration, isFixed = false) {
    duration = isNaN(duration) ? 1800 : duration;
    let m = document.createElement('div');
    m.innerText = msg;

    let element = document.getElementById(father_element);
    element.appendChild(m);

    if (isFixed) {
        const w = 200;
        let height = window.innerHeight / 2;
        let width = (window.innerWidth - w) / 2 + w;
        m.style.cssText = `font-family:siyuan;max-width:none;min-width: 300px;padding:0 14px;height: 40px;color: rgb(255, 255, 255);line-height: 39px;text-align: center;border-radius: 4px;position: fixed;top: ${height}px;left: ${width}px;transform: translate(-50%, -50%);z-index: 999999;background: rgba(0, 0, 0,.7);font-size: 18px;`;
    } else {
        m.style.cssText = `font-family:siyuan;max-width:none;min-width: 300px;padding:0 14px;height: 40px;color: rgb(255, 255, 255);line-height: 39px;text-align: center;border-radius: 4px;position: absolute;top: 50%;left: ${y}%;transform: translate(-50%, -50%);z-index: 999999;background: rgba(0, 0, 0,.7);font-size: 18px;`;
    }

    // document.body.appendChild(m);
    // let element
    // if (isById) {
    //     element = document.getElementById(father_element);
    // } else {
    //     element = document.body;
    // }
    // let element = document.getElementById(father_element);
    // element.appendChild(m);
    setTimeout(function () {
        var d = 0.5;
        m.style.webkitTransition = '-webkit-transform ' + d + 's ease-in, opacity ' + d + 's ease-in';
        m.style.opacity = '0';
        setTimeout(function () {
            // document.body.removeChild(m)
            element.removeChild(m);
        }, d * 1000);
    }, duration);
}